module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/id1HX6/tc-custom/9781401688493.jpg?1725275922980",
      "alt": "This image is the cover for the book River, The River Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("River, The River Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“The River is a story that will transform how you see yourself and the world.” —Andy Andrews, "), _c('i', [_vm._v("New York Times")]), _vm._v(" best-selling author of "), _c('i', [_vm._v("The Noticer")]), _vm._v(", "), _c('i', [_vm._v("The Traveler’s Gift")]), _vm._v(", and "), _c('i', [_vm._v("How Do You Kill 11 Million People?")])]), _c('p', [_c('b', [_vm._v("“You were made for The River . . .”")])]), _c('p', [_vm._v("Gabriel Clarke is mysteriously drawn to The River, a ribbon of frothy white water carving its way through steep canyons high in the Colorado Rockies. The rushing waters beckon him to experience freedom and adventure.")]), _c('p', [_vm._v("But something holds him back—the memory of the terrible event he witnessed on The River when he was just five years old—something no child should ever see.")]), _c('p', [_vm._v("Chains of fear and resentment imprison Gabriel, keeping him from discovering the treasures of The River. He remains trapped, afraid to take hold of the life awaiting him.")]), _c('p', [_vm._v("When he returns to The River after years away, his heart knows he is finally home. His destiny is within reach. Claiming that destiny will be the hardest—and bravest—thing he has ever done.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Neale\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0